import { defineStore } from 'pinia';

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    messages: [],
  }),
  actions: {
    showMessage(msg, type = 'info', description = '') {
      this.messages.push({
        title: (description.length) ? msg : '',
        text: (description.length) ? description : msg,
        timeout: 5000,
        color: type,
        vertical: !!description.length,
      });
    },
  },
});
